import { I18nextProviderProps } from 'react-i18next';

export default class HookFormHelper {
  /**
   * Вывод ошибок из hook form.
   * Выводит текст ошибки либо string либо object.
   * Если object, то там есть данные для i18n.
   *
   * @param message текст ошибки или объект в виде объекта { key?: string; options?: object }.
   * @param t для перевода, "ns" по умолчанию не имеет значение.
   * @returns Ошибку напрямую или перевод в зависимости от языка.
   */
  static getI18nHookFormErrorMessage = (message: string | undefined, t: I18nextProviderProps['i18n']['t']): string => {
    const errorMessage = (message ?? '') as string | { key?: string; options?: object };

    if (typeof errorMessage === 'object') {
      if (errorMessage?.key) {
        return t(errorMessage.key, { ...errorMessage.options });
      }

      return JSON.stringify(errorMessage);
    }

    return errorMessage;
  };
}
